import { useQuery } from "@tanstack/react-query"
import { type FC, type ReactNode } from "react"

import VersionContext from "."

const VersionContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { data: version } = useQuery({
		queryKey: ["version"],
		async queryFn() {
			const response = await fetch("/api/version")
			if (!response.ok) return null
			return response.text()
		},
		refetchInterval: 1000 * 10,
	})

	return <VersionContext.Provider value={version ?? null}>{children}</VersionContext.Provider>
}

export default VersionContextProvider
